<template>
  <li role="presentation"><hr class="dropdown-divider" role="separator" aria-orientation="horizontal"></li>
</template>

<script setup>
// Replaces bootstrap-vue's <b-dropdown-divider> with the same markup.
defineOptions({
  name: 'BDropdownDivider',
})
</script>
